import { DelayReason, DelayReasonRequest } from '../../../../../entities/DelayReason';
import {
  DELETE_DELAY_REASON_REQUEST,
  GET_DELAY_REASONS_ERROR,
  GET_DELAY_REASONS_REQUEST,
  GET_DELAY_REASONS_SUCCESS,
  SAVE_DELAY_REASON_REQUEST,
} from './constants';

export const getDelayReasonsRequest = () => ({
  type: GET_DELAY_REASONS_REQUEST,
  payload: {},
});

export const getDelayReasonsSuccess = (delayReasons: DelayReason[]) => ({
  type: GET_DELAY_REASONS_SUCCESS,
  payload: { delayReasons },
});

export const getDelayReasonsError = (error: Error | null) => ({
  type: GET_DELAY_REASONS_ERROR,
  payload: { error },
});

export const saveDelayReasonRequest = (delayReason: DelayReasonRequest) => ({
  type: SAVE_DELAY_REASON_REQUEST,
  payload: { delayReason },
});

export const deleteDelayReasonRequest = (id: number) => ({
  type: DELETE_DELAY_REASON_REQUEST,
  payload: { id },
});

export type Actions =
  | ReturnType<typeof getDelayReasonsRequest>
  | ReturnType<typeof getDelayReasonsSuccess>
  | ReturnType<typeof getDelayReasonsError>
  | ReturnType<typeof saveDelayReasonRequest>
  | ReturnType<typeof deleteDelayReasonRequest>;
